<template>
    <div>
      <div class="columns">
        <div class="column">
          <div class="box centered">
            <a @click.prevent="reimport">Reimport Videos</a>
            <b-loading :active="reimporting" :is-full-page="false"></b-loading>
          </div>
        </div>
      </div>

      <div class="field">
        <form action="#" method="POST" @submit.prevent="updateQuery">
          <input type="text" class="input" placeholder="Search" v-model="query">
        </form>
      </div>

      <div class="columns is-multiline" v-if="videos">
          <div class="column is-one-quarter" :key="video.id" v-for="video in videos">
              <video-card :video="video"></video-card>
          </div>
      </div>
      <loading v-else></loading>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
import VideoCard from "@/components/Video-Card";
import { GET_FEED_VIDEOS, REIMPORT_FEED_CONTENT } from "@/store/actions";
import { SET_FEED_VIDEOS_QUERY } from "@/store/mutations";

export default {
  name: "feed-videos",
  components: {
    Loading,
    VideoCard
  },
  data() {
    return {
      loading: false,
      end: false,
      reimporting: false,
      query: ''
    };
  },
  mounted() {
    if (!this.videos || this.videos.length <= 0) {
      this.$store.dispatch(GET_FEED_VIDEOS, this.feedId);
    }

    window.addEventListener("scroll", this.handleBottomScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleBottomScroll);
  },
  computed: {
    feedId() {
      return this.$route.params.id;
    },
    videos() {
      return this.$store.state.feed.videos;
    }
  },
  watch: {},
  methods: {
    /**
     * Handle scroll to bottom, load more videos
     */
    handleBottomScroll(ev) {
      let { innerHeight, pageYOffset } = window;
      if (innerHeight + pageYOffset >= document.body.offsetHeight - 250) {
        this.getVideos();
      }
    },
    /**
     * Retrieve videos from the api
     */
    getVideos() {
      if (this.loading || this.end) {
        return;
      }

      this.loading = true;
      this.$store
        .dispatch(GET_FEED_VIDEOS, this.feedId)
        .then(res => {
          if (res.data.content.length <= 0) {
            this.end = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reimport(){
      this.reimporting = true;
      this.$store.dispatch(REIMPORT_FEED_CONTENT, {
        id: this.feedId,
        reimport_type: "videos"
      }).then((res) => {
        if(res && res.status === 200){
          this.$success(`Videos were reimported`);
        }
      }).finally(() => {
        this.reimporting = false;
      });
    },
    updateQuery(){
      this.$store.commit(SET_FEED_VIDEOS_QUERY, this.query);
      this.getVideos();
    }
  }
};
</script>

<style scoped>
.centered{
  text-align: center;
}
</style>
